
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"8","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.578 7.023c.12.6.266 1.053.438 1.36.177.307.416.526.718.656.302.135.745.203 1.329.203h.734c.354 0 .625.021.812.063.188.041.357.114.508.218.151.11.302.284.453.524.151.245.326.627.524 1.148l-.586.282a3.09 3.09 0 00-.336-.594.942.942 0 00-.281-.266.89.89 0 00-.32-.101 4.61 4.61 0 00-.555-.024H3.922c-.714 0-1.32-.21-1.82-.633-.5-.416-.88-1.028-1.141-1.836C.7 7.216.57 6.273.57 5.195v-.523c0-.927.13-1.695.39-2.305.26-.61.656-1.088 1.187-1.437C2.68.576 3.354.398 4.172.398c.953 0 1.687.316 2.203.946.52.625.781 1.526.781 2.703 0 .77-.135 1.435-.406 1.992a2.798 2.798 0 01-1.156 1.258c-.5.286-1.07.43-1.711.43-.386 0-.75-.058-1.094-.172a4.047 4.047 0 01-1.078-.602l-.133.07zm2.344-6c-.63 0-1.12.274-1.469.82-.344.542-.515 1.326-.515 2.352 0 .552.046 1.016.14 1.39.1.37.23.67.39.9.167.223.358.385.571.484.214.093.435.14.664.14.646 0 1.138-.25 1.477-.75.338-.505.508-1.237.508-2.195 0-.995-.152-1.766-.454-2.312-.302-.553-.74-.829-1.312-.829z","fill":"currentColor"}})])
          )
        }
      }
    